import { Snackbar, Alert, AlertTitle } from '@mui/material';

export default function ExportResultToast({
  open,
  severity = 'success',
  title = '',
  message = '',
  onClose,
  autoHideDuration = 14000,
}) {
  return (
    <Snackbar
      open={open}
      onClose={onClose}
      autoHideDuration={autoHideDuration}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        sx={{ width: '100%', boxShadow: 2 }}>
        {title ? <AlertTitle>{title}</AlertTitle> : null}
        {message}
      </Alert>
    </Snackbar>
  );
}
